import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { httpsCallable } from "firebase/functions";
import { TailSpin } from "react-loader-spinner";
import { fireFunctions } from "../../../../../Firebase/firebase";
import { STATE_ENUMS } from "../../../petitionList/jurisdictionEnums";
import Summary from "./Summary";
import ExpandedChamber from "./ExpandedChamber";

const CHAMBERS = {
  stateHouse: { label: "FL House Districts", count: 120 },
  stateSenate: { label: "FL Senate Districts", count: 40 },
};

const LoadingWrapper = styled.div`
  padding-top: 14px;
  display: flex;

  @media screen and (min-width: 540px) {
    padding-top: 22px;
  }
`;

const TailSpinWrapper = styled.div`
  padding-left: 12px;
`;

const OverallOpinionFl = ({ fireDbPetitionPath }) => {
  const [resultsData, setResultsData] = useState(null);
  const [expandedChamber, setExpandedChamber] = useState(null);

  useEffect(() => {
    const getResultsBackend = httpsCallable(
      fireFunctions,
      "getStanceCountState",
    );
    getResultsBackend({
      state: STATE_ENUMS.fl,
      fireDbPetition: fireDbPetitionPath,
    }).then((results) => {
      setResultsData(results.data);
    });
  }, []);

  if (!resultsData) {
    return (
      <LoadingWrapper>
        Fetching results...{" "}
        <TailSpinWrapper>
          <TailSpin color="black" height={24} width={24} />
        </TailSpinWrapper>
      </LoadingWrapper>
    );
  }

  if (expandedChamber) {
    const { label, count } = CHAMBERS[expandedChamber];
    return (
      <ExpandedChamber
        label={label}
        count={count}
        data={resultsData[expandedChamber]}
        onCollapse={() => setExpandedChamber(null)}
      />
    );
  }

  return (
    <Summary
      total={resultsData?.stateHouse?.TOTAL ?? { YES: 0, NO: 0 }}
      onExpandHouse={() => setExpandedChamber("stateHouse")}
      onExpandSenate={() => setExpandedChamber("stateSenate")}
    />
  );
};

OverallOpinionFl.propTypes = {
  fireDbPetitionPath: PropTypes.string,
};

export default OverallOpinionFl;
